import styled from 'styled-components';
import Typography from 'antd/es/typography';
export const TitleText = styled(Typography.Text)`
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  margin-bottom: 4px;
  letter-spacing: normal;
  color: #111827;
`;
export const TimeText = styled(Typography.Text)`
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  margin-bottom: 0;
  letter-spacing: normal;
  color: #6B7280;
`;
export const MsgText = styled(Typography.Text)`
  font-family: Roboto;
  font-size: 13px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  margin-bottom: 4px;
  letter-spacing: normal;
  color: #6B7280;
`;
